import { React, useState, useEffect } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import classes from "./index.module.scss";
import { ENDPOINT, KEY } from "config/constants";
import AuthService from "services/auth.service";
import accessHeader from "services/headers/access-header";
import swal from "sweetalert";

const UpdateCard = ({ selectedData, ...props }) => {
  const [formData, setFormData] = useState(selectedData);
  const [file, setFile] = useState([]);
  const [addAdmin, setAddAdmin] = useState(false);
  const [uploadFile, setUploadFile] = useState();

  useEffect(() => {
    setFormData(selectedData);
  }, [selectedData]);

  const handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setFormData((prevalue) => {
      return {
        ...prevalue, // Spread Operator
        [name]: value,
      };
    });
  };

  // const handleSubmit = async (data) => {
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const res = await AuthService.patchMethod(
        `${ENDPOINT.card_user.edit_user.url}${selectedData.id}`, true, formData);
      setAddAdmin(props.onHide);
      setTimeout(() => {
        props.subAdminAllData();
      }, 1000);
      console.log(res);
      
    } catch (err) {
      swal("Error", `${AuthService.errorMessageHandler(err)}`, "error");
    }
  };

  //   image upload and review

  function uploadSingleFile(e) {
    setUploadFile({ uploadFile: e.target.files[0] });
    let ImagesArray = Object.entries(e.target.files).map((e) =>
      URL.createObjectURL(e[1])
    );
    console.log(ImagesArray);
    setFile([...file, ...ImagesArray]);
    console.log("file", file);
  }

  function upload(e) {
    e.preventDefault();
    console.log(file);
  }

  function deleteFile(e) {
    const s = file.filter((item, index) => index !== e);
    setFile(s);
    console.log(s);
  }

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Button variant="close" onClick={props.onHide}>
          <i className={"fal fa-times"}></i>{" "}
        </Button>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={12}>
                <div className={classes.box}>
                  <Row>
                    <Col md={8}>
                      <Col md={12} className={"mb-3"}>
                        <Form.Check
                          inline
                          type={"radio"}
                          label={`Google`}
                          id={`google`}
                          name={"cardSponsor"}
                          value={"google"}
                          checked={formData.cardSponsor === "google"}
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          type={"radio"}
                          label={`Internal`}
                          id={`Internal`}
                          name={"cardSponsor"}
                          value={"internal"}
                          checked={formData.cardSponsor === "internal"}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={12} className={"mb-3"}>
                        <Form.Control
                          type="text"
                          placeholder="Click here"
                          onChange={handleChange}
                          name="cardTitle"
                          required
                          value={formData.cardTitle}
                        />
                      </Col>
                      <Col md={12} className={"mb-3"}>
                        <Form.Control
                          type="text"
                          placeholder="URL link"
                          onChange={handleChange}
                          name="cardUrlLink"
                          required
                          value={formData.cardUrlLink}
                        />
                      </Col>
                      <Col md={12} className={"mb-3"}>
                        <textarea
                          onChange={handleChange}
                          name="description"
                          placeholder="description here..."
                          required
                          value={formData.description}
                        ></textarea>
                      </Col>
                      <Col md={12} className={"mb-3"}>
                        <label className={"fileUpload"} htmlFor="upload-photo">
                          <Form.Control
                            type="file"
                            id={"upload-photo"}
                            disabled={file.length === 1}
                            className="form-control"
                            onChange={uploadSingleFile}
                          />
                        </label>
                      </Col>
                      <Col md={12} className={"mb-3"}>
                        <div className="form-group preview">
                          {file.length > 0 &&
                            file.map((item, index) => {
                              return (
                                <div className={"preview"} key={item}>
                                  <img src={item} alt="" />
                                  <Button
                                    type="button"
                                    onClick={() => deleteFile(index)}
                                  >
                                    <i className={"fal fa-times"}></i>
                                  </Button>
                                </div>
                              );
                            })}
                          {formData.picture && file.length === 0 && (
                            <div className={"preview"}>
                              <img
                                src={
                                  "https://api.gowild.appscorridor.com" +
                                  formData.picture
                                }
                                alt=""
                              />
                              <Button
                                type="button"
                                onClick={() =>
                                  setFormData({
                                    ...formData,
                                    picture: "",
                                  })
                                }
                              >
                                <i className={"fal fa-times"}></i>
                              </Button>
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col md={12} className={"mb-3 text-center"}>
                        <button
                          type="submit"
                          className="btn btn-primary btn-block w-50"
                          // onClick={upload}
                        >
                          Update
                        </button>
                      </Col>
                    </Col>
                    <Col md={4}>
                      <div class="card mt-3" style={{ width: "100%" }}>
                        <img
                          src={formData.cardUrlLink}
                          class="card-img-top"
                          alt="..."
                        />
                        <div class="card-body">
                          <h5 class="card-title">{formData?.cardTitle}</h5>
                          <p class="card-text">{formData.description}</p>
                          <a href="#" class="btn btn-primary">
                            Go somewhere
                          </a>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UpdateCard;
